import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserById, getDocuments, getProfilePicture } from './../actions/user-api';
import { GetPartnerById, GetEtablissementById, GetEtablissementsByPartnerId, GetUsersByPartnerIdAndEtablissementIdDefaultAnticipa, GetUsersByPartnerIdAndEtablissementIdDefaultFacilita, GetUsersByPartnerIdAndEtablissementIdDefaultSerenita } from './../actions/partner/partner';
import * as R from 'ramda';
import JwtDecode from 'jwt-decode';
import * as axios from 'axios';
import { ToastContainer } from 'react-toastify';

// Partner
// ==========================================
// Partner: Common
import { Navbar } from './_common/navbar';

// Partner: Views
import { Dossiers } from './dossiers';
import { Teleconseillers } from './teleconseillers';
import { Selfcare } from "./selfcare";
import { AjouterDossier } from './_common/ajouterDossier/index';
import { Audit } from './audit';
import { getUserRepresentatives } from '../actions/backoffice/partners';
import { FileTypes } from '../constants/utils/fileTypes';
import { FetchAllTeleconseillers } from '../actions/funecap/teleconseiller';

export const Funecap = () => {
	const searchQuery = useLocation();
	const router = useSelector(state => state.router);
	const dispatch = useDispatch();
	const userReducer = useSelector(state => state.user);
	const partnerReducer = useSelector(state => state.partnerReducer);
	const teleconseillersReducer = useSelector(state => state.teleconseillersReducer);
	const dossiersReducer = useSelector(state => state.dossiersReducer);
	const selfcareReducer = useSelector((state) => state.selfcareReducer);

	const activityLogReducer = useSelector(state => state.activityLogReducer);
	const accessToken = localStorage.getItem("access_token");

	const [hasLoadedInit, setHasLoadedInit] = useState(false);
	const [anticipaUsers, setAnticipaUsers] = useState(undefined);
	const [facilitaUsers, setFacilitaUsers] = useState(undefined);
	const [serenitaUsers, setSerenitaUsers] = useState(undefined);
	const [isPartner, setIsPartner] = useState(false);
	const [showSerenita, setShowSerenita] = useState(false);

	const pageQuery = new URLSearchParams(searchQuery.search);
	let page = pageQuery.get('page');
	console.log('Serenicare');

	useEffect(() => {
		if (!R.isNil(accessToken)) {
			axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
			var decoded = JwtDecode(accessToken);
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			}
			if (!R.isNil(decoded) && !R.isNil(decoded["PartnerId"])) {
				dispatch(GetPartnerById(decoded["PartnerId"])).then(() => {
					if (R.isNil(decoded["EtablissementId"])) {
						dispatch(GetEtablissementsByPartnerId(decoded["PartnerId"]))
						.then(() => setHasLoadedInit(true));
					}
				});
				if (!R.isNil(decoded["EtablissementId"])) {
					dispatch(GetEtablissementById(decoded["PartnerId"], decoded["EtablissementId"])).then(() => {
						setHasLoadedInit(true);
					});
				}

				let rolesFromToken = decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
				let roles = Array.isArray(rolesFromToken) ? rolesFromToken : [rolesFromToken];
				setIsPartner(roles.includes("PARTNER"));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {

		// Remove isPartner condition to fetch all téléconseillers to be displayed in dossiers filter
		if (!R.isNil(partnerReducer.partner)) {
			dispatch(FetchAllTeleconseillers(1, "", "PARTNER,ETABLISSEMENT", "creationDate", "true", partnerReducer.partner.id));
		}
		// if(isPartner && !R.isNil(partnerReducer.partner)){
		// 	dispatch(FetchAllTeleconseillers(1, "", "PARTNER,ETABLISSEMENT", "creationDate", "true", partnerReducer.partner.id));
		// }
		
	}, [isPartner, partnerReducer.partner])

	useEffect(() => {
		if (!R.isNil(userReducer.user)) {
			dispatch(getDocuments(userReducer.user));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userReducer.user]);

	useEffect(() => {
		const profilePicture = userReducer.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if (!R.isNil(profilePicture))
			dispatch(getProfilePicture(userReducer.user.id, profilePicture.fileName));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userReducer.documents]);

	if (R.isNil(accessToken)) {
		window.location = "/"
	}else{
		var decoded = JwtDecode(accessToken);
		if(!R.isNil(decoded["exp"])){
			var tokenExpirationDate = new Date(parseInt(decoded["exp"]) * 1000);
			if(tokenExpirationDate > new Date()){
				axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
				// console.log("HERE")
				//window.location = "/"
			}
		}
	}

	if (R.isNil(partnerReducer.partner))
		return 'Chargement...';
	if (R.isNil(partnerReducer.etablissement))
		return 'Chargement...';

	if (R.isNil(userReducer.user))
		return 'Chargement...';



	return (
		<React.Fragment>
			<ToastContainer />
			<div className={"layout layout-row" + (!R.isNil(partnerReducer.partner.color) && partnerReducer.partner.color !== "" ? "" : " bg-gradient-secondary")} style={{ backgroundColor: "#" + partnerReducer.partner.color }}>
				<h1 className="sr-only visually-hidden">Assist@</h1>
				<Navbar location={router.location} userInfo={userReducer} user={userReducer.user} partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} profilePicture={userReducer.profilePicture} isPartner={isPartner} showSerenita={showSerenita} />
				<main role="main" className="view flex-grow-1 bg-gradient-light">
					<h1 className="sr-only visually-hidden">Assist@: Main</h1>
					<Switch>
						<Route path="/funecap/dossiers/create">
							<AjouterDossier partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} />
						</Route>
						<Route path="/funecap/dossiers">
							<Dossiers partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} dossiersReducer={dossiersReducer} user={userReducer.user} teleconseillers={teleconseillersReducer.items} isPartner={isPartner} />
						</Route>{" "}
						<Route path="/funecap/selfcare">
							<Selfcare partner={partnerReducer.partner} etablissement={partnerReducer.etablissement} selfcareReducer={selfcareReducer} user={userReducer.user} teleconseillers={teleconseillersReducer.items} isPartner={isPartner} />
						</Route>
						<Route path="/funecap/teleconseillers">
							<Teleconseillers
								teleconseillersReducer={teleconseillersReducer}
								partner={partnerReducer.partner}
								etablissement={partnerReducer.etablissement}
								isPartner={isPartner}
								partnerstate={partnerReducer}
								anticipaUsersRepresentative={anticipaUsers}
								facilitaUsersRepresentative={facilitaUsers}
								serenitaUsersRepresentative={serenitaUsers}
							/>
						</Route>
						<Route path="/funecap/audit">
							<Audit activityLogReducer={activityLogReducer} partner={partnerReducer.partner} teleconseillersReducer={teleconseillersReducer} />
						</Route>
						<Route
							render={() => {
								return <Redirect exact to="/funecap/dossiers" />;
							}}
						/>
					</Switch>
				</main>
			</div>
		</React.Fragment>
	);
};